import i18n from 'i18next';
import translations from './translations.json'
import { initReactI18next } from 'react-i18next';

// Get the current locale from CC
const locale = ddc.global.currentLocale || 'en_US';

i18n.use(initReactI18next)
	.init({
		lng: locale,
		fallbackLng: 'en_US',
		interpolation: {
			// React already does escaping
			escapeValue: false,
		},
		resources: translations,
		debug: true,
	});

export default i18n;